import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_chervon_grey",
  "use": "icon-ic_chervon_grey-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic_chervon_grey\"><path fill=\"#C6C6C8\" d=\"m7.293 5.707 1.414-1.414L16.414 12l-7.778 7.778-1.414-1.414L13.586 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol